import { EnumTipoConfigGroupSign } from "constants/EnumTipoConfigGroupSign";
import { useContext, useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Tabs from "shared/components/tabs/Tabs";
import { Panel } from "shared/components/panel/Panel";
import BodyPanel from "shared/components/panel/BodyPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import { UserContext } from "context/UserContext";
import { TabConfiguracaoCondominio } from "./configuracaoCondominio/TabConfiguracaoCondominio";
import { TabConfiguracaoDocumento } from "./configuracaoDocumento/TabConfiguracaoDocumento";

const GroupSign: React.FC = () => {
  const { usuarioLogado } = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams(); 
  const [activeTab, setActiveTab] = useState<EnumTipoConfigGroupSign>(
    (searchParams.get("tab") as EnumTipoConfigGroupSign) || EnumTipoConfigGroupSign.CONFIGURACAO_CONDOMINIO
  );

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const abas = [
    {
      id: 1,
      title: "Configuração por condomínio",
      content: <TabConfiguracaoCondominio />,
      tipoTab: EnumTipoConfigGroupSign.CONFIGURACAO_CONDOMINIO,
    },
    {
      id: 2,
      title: "Configuração de documentos",
      content: <TabConfiguracaoDocumento />,
      tipoTab: EnumTipoConfigGroupSign.CONFIGURACAO_DOCUMENTOS,
    },
  ];

  return (
    <Panel
      headerPanel={
        <HeaderPanel
          title="Configurações de assinatura digital"
          ocultarCondominio={!usuarioLogado.condominioContextoId}
          abaAtual={activeTab}
        />
      }
    >
      <BodyPanel noPadding>
        <Tabs tabs={abas} activeTab={activeTab} changeActiveTab={setActiveTab} />
      </BodyPanel>
    </Panel>
    
  );
};

export default GroupSign;